/**
 * Chemical Template Models
 *
 * Interfaces for reusable chemical application templates.
 */

// ============================================
// TEMPLATE CHEMICAL INTERFACES
// ============================================

export interface TemplateChemical {
  name: string;
  rate: string;
  purpose: string;
}

// ============================================
// CHEMICAL TEMPLATE INTERFACES
// ============================================

export interface ChemicalTemplate {
  id: string;
  name: string;
  description: string;
  chemicals: TemplateChemical[];
  targetCrops: string[];
  targetPests?: string[];
  applicationTiming?: string;
  totalVolume: string;
  estimatedCostPerAcre?: number;
  notes?: string;
  createdAt: string;
  usageCount: number;
}
